import React from 'react';
import { api, Order } from '@restaurant/api';
import { Checkbox, Typography } from 'antd';
import { formatCurrency } from '~/utils/currency';
import message from '~/utils/message';

const Tax = ({
  order,
  setLoading,
  onSuccess,
}: {
  order: Order;
  setLoading: (val: boolean) => void;
  onSuccess: () => void;
}) => {
  const handleToggleTaxActive = async () => {
    setLoading(true);
    // Update order tax to backend.
    try {
      await api.updateOrderTax(order.orderId, !order.tax?.isApplied);
      onSuccess();
    } catch (error: any) {
      message.error('Failed to update order tax: ' + error.message);
    }
    setLoading(false);
  };
  const taxAmount = formatCurrency(order?.tax?.amount ?? 0);

  return (
    <div className="mx-4">
      <Typography.Text type="secondary">Tax</Typography.Text>
      {order.tax == null ? (
        <Typography.Title level={5} style={{ margin: 0 }} className="py-1">
          None
        </Typography.Title>
      ) : (
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={handleToggleTaxActive}
        >
          <div className="d-flex py-1">
            <Checkbox
              checked={order.tax.isApplied}
              onClick={handleToggleTaxActive}
            />
            <Typography.Title level={5} className="ml-2">
              {order.tax.taxType}
            </Typography.Title>
          </div>
          <Typography.Text>
            {order.tax.isApplied ? taxAmount : <s>{taxAmount}</s>}
          </Typography.Text>
        </div>
      )}
    </div>
  );
};

export default Tax;
